import React from "react";

const Intro = () => {
  const introContent = {
    image: "assets/img/slider/1.jpg",
    name: "Adriano Smith",
    designation: "Web Developer",
    text: (
      <>
        <p>
          Namaskar, my name is Kshitij Raj Lohani and I began using WordPress when it first
          began. I’ve spent most of my waking hours for the last ten years
          designing, programming and operating WordPress sites.
        </p>
        <p>
          One of my specialties is taking an idea from scratch and creating a
          full-fledged platform. I go beyond to produce sites with a unique,
          outstanding, contemporary look-and-feel. With extensive knowledge of
          web mechanics, I’m able to optimize complex integrations to require
          little-to-no maintenance while running on their own for years.
        </p>
      </>
    ),
  };

  return (
    <>
      {/* <div className="top_author_image">
        <img src={introContent.image} alt="about" />
      </div> */}
      {/* <div className="about_title">
        <h3>{introContent.name}</h3>
        <span>{introContent.designation}</span>
      </div> */}
      <div className="about_text">{introContent.text}</div>
    </>
  );
};

export default Intro;
